import * as React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { desktop, tablet } from '../../../BreakPoints';
import { colors } from '../../../colors/color';
import { Label } from '../../../Label';

type FooterProps = {
    siteId?:string
}
export const Footer = ({siteId}: FooterProps): JSX.Element => {
    return (
        <FooterContainer className="footer">
            <LogoContainer>
                <img src="/images/amorg_logo_blue.svg" />
            </LogoContainer>


            <SiteId>
                <Label>
                    {siteId || ''}
                </Label>
            </SiteId>
            
            <Info>
                © 2022 AMORG ApS | CVR: 43511750
            </Info>
            <FooterNav>
                <ul>
                    <li><NavLink to="/support" activeClassName="active">Kontakt & Support</NavLink></li>
                </ul>
                <ul>
                    <li><NavLink to="/privacy" activeClassName="active">Privatlivspolitik</NavLink></li>
                </ul>
            </FooterNav>
                
            
        </FooterContainer>
    );
}


const FooterContainer = styled.div`
    
    align-self: end;
    background: ${colors.footer.background};
    background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(232,243,255,1) 25%, rgba(232,243,255,1) 75%, rgba(255,255,255,1) 100%);
    color: ${colors.text.normal};
    
    // height: 60px;
    padding: 1rem;
    width: 100%;
    z-index: 1;
    box-sizing: border-box;

    display: grid;
    grid-area: footer;
    grid-template-areas: "logo siteid info footernavigation";

    grid-template-columns: min-content min-content 1fr min-content;
    grid-template-rows: auto;


    @media (max-width: ${tablet}px) {
        grid-template-columns: min-content 1fr;
        grid-template-areas: 
            "logo footernavigation"
            "logo info";
        height: auto;
        width: 100vw;
        box-sizing: border-box;
    }
`;


const LogoContainer = styled.span`
    display: block;
    grid-area: logo;
    margin-left: 0px;
    height: 32px;
    width: 32px;
    align-self: end;

    @media (min-width: ${desktop}px) {
        margin-left: 24px;
    }


`;

const SiteId = styled.span`
    
    display:none;
    

    @media (min-width: ${desktop}px) {
        grid-area: siteid;
        display:flex;
        flex-direction: column;
        align-self: center;
        white-space: nowrap;
        margin-left: 8px;
    }

`;

const Info = styled.span`
    align-self: center;
    grid-area: info;
    justify-self: center;
    font-size: 0.8rem;

    @media(min-width: ${tablet}px){
        
    }
`

const FooterNav = styled.div`
    align-self: flex-start;
    display: flex;
    grid-area: footernavigation;

    & ul{
        list-style-type: none;
        margin-bottom: 0;
        margin-top: 0;

        & li{
            text-align:right;
            margin-bottom: 5px;
            white-space: nowrap;

        }
    }

    & a{
        color:${colors.link.footer.normal};
        text-decoration: none;
        transition: color .2s ease;

        &:hover{
            color: ${colors.link.footer.hover};
        }
    }

    @media(min-width: ${desktop}px){
        flex-direction: row;
        align-self: center;
        
    }

`;